<template>
  <div class="Datalist">
    <app-header></app-header>

    <el-container style="border: 1px solid #eee">
      <app-sidebar></app-sidebar>
      <el-main>
        <app-breadcrumb></app-breadcrumb>
        <!-- Search Sector -->
        <div class="Searchbar">
          <form class="el-form query-form el-form--label-right el-form--inline">
            <div class="el-form-item el-form-item--medium">
              <label for="name"
                     class="el-form-item__label"
                     style="width: 60px;">搜索</label>
              <div class="el-form-item__content">
                <div class="el-input el-input--medium">
                  <el-input autocomplete="off"
                            placeholder="请输入搜索内容"
                            type="text"
                            rows="2"
                            v-model="search"
                            clearable
                            @clear="clearSearch"
                            ref="searchinput"></el-input>
                </div>
              </div>
            </div>
            <div class="el-form-item el-form-item--medium">
              <label for="date"
                     class="el-form-item__label"
                     style="width: 60px;">日期</label>
              <el-date-picker v-model="dateRange"
                              type="daterange"
                              unlink-panels
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              style="height:36px;line-height:36px;"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              @change="getdateRange"></el-date-picker>
            </div>
            <div class="el-form-item el-form-item--medium">
              <div class="el-form-item__content">
                <button type="button"
                        class="el-button el-button--primary el-button--medium"
                        @click="searchStr">
                  <i class="el-icon-search"></i>
                  <span>搜索</span>
                </button>
                <button type="button"
                        class="el-button filter-item el-button--primary el-button--medium"
                        style="margin-left: 10px;"
                        @click="jtadd">
                  <i class="el-icon-edit"></i>
                  <span>添加</span>
                </button>
                <el-button type="danger"
                           class="el-button filter-item el-button--primary el-button--medium"
                           style="margin-left: 10px;"
                           :disabled="plif"
                           @click="jtdel">
                  <i class="el-icon-delete"></i>
                  <span>批量删除</span>
                </el-button>
              </div>
            </div>
          </form>
        </div>
        <!-- Search Sector -->
        <!--
          全部载入数据，分页方式
          :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
        -->
        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  stripe
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="45"></el-table-column>
          <el-table-column prop="name"
                           label="姓名"
                           width="80"></el-table-column>
          <el-table-column prop="age"
                           label="身份证号"
                           width="170"></el-table-column>
          <el-table-column prop="sex"
                           label="性别"
                           width="50"></el-table-column>
          <el-table-column prop="school"
                           label="证书编号"
                           width="125"></el-table-column>
          <el-table-column prop="fathername"
                           label="职业技能名称"
                           width="140"></el-table-column>
          <el-table-column prop="fathermobile"
                           label="级别"
                           width="50"></el-table-column>
          <el-table-column prop="picurl"
                           label="头像"></el-table-column>
          <el-table-column prop="fz_date"
                           label="发证日期"
                           width="95"></el-table-column>
          <el-table-column prop="ptime"
                           label="填写时间"
                           :formatter="dateFormat"
                           width="160"></el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="295">
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="warning"
                           icon="el-icon-edit"
                           @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger"
                           icon="el-icon-delete"
                           @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                <el-dropdown trigger="click">
                  <el-button type="success">
                    打印
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handlePrint1( scope.row.id)">直接打印</el-dropdown-item>
                    <el-dropdown-item @click.native="handlePrint2( scope.row.id)">打印预览</el-dropdown-item>
                    <el-dropdown-item @click.native="handlePrint3( scope.row.id)">打印维护</el-dropdown-item>
                    <el-dropdown-item @click.native="handlePrint4(scope.row.id)">打印设计</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页栏 -->
        <div class="block">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"></el-pagination>
        </div>
        <!-- 分页栏 -->
      </el-main>
    </el-container>
    <!-- 表格尾部 -->

    <form id="form1"
          v-show="isshow">
      <table border="1"
             width="300"
             id="tb01">
        <tr>
          <td width="133"
              id="mtb001">
            <h2 style="background:pink;">{{this.items.fathername}}</h2>
          </td>
        </tr>
      </table>
      <table border="1"
             width="300"
             height="106"
             cellspacing="0">
        <tr>
          <td>姓名</td>
          <td>年龄</td>
          <td>性别</td>
        </tr>
        <tr>
          <td>{{this.items.name}}</td>
          <td>{{this.items.age}}</td>
          <td>{{this.items.sex}}</td>
        </tr>
      </table>
    </form>
  </div>
</template>

<script>
import { isObject, isNumber } from 'util'
import { getLodop } from '@/assets/js/LodopFuncs'
import { exit } from 'process'

export default {
  name: 'Datalist',
  data () {
    return {
      search: '', // 搜索
      dateRange: '',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      plif: true,
      items: [],
      isshow: false
    }
  },
  mounted () {
    this.getdata()
  },
  methods: {
    //获取数据
    getdata () {
      this.$http
        // dev
        // .get(
        //   '/api/article/' +
        //     this.$store.state.userid +
        //     '/' +
        //     this.pageSize +
        //     '/' +
        //     this.currentPage
        // )
        // product
        .get('/api/article/article_list', {
          params: {
            user_id: this.$store.state.userid,
            num: this.pageSize,
            page: this.currentPage
          }
        })
        .then(res => {
          var rcode = res.data.code
          this.totalNum = res.data.data.total
          this.tableData = res.data.data.zs_list
          if (rcode !== 200) {
            // 返回并清除token信息并跳转到登录页面
            this.$store.commit('REMOVE_COUNT')
            this.$router.push('/login')
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //重置
    resetData () {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    //清除数据
    clearSearch(){
      this.getdata()
    },
    // 修改更新记录
    handleEdit (index, row) {
      this.$router.push({
        path: '/editdata',
        query: {
          id: row.id
        }
      })
    },
    // 单笔记录删除
    handleDelete (index, row) {
      this.$http
        // dev
        // .delete('/api/article/' + row.id + '/' + this.$store.state.userid)
        // product
        .delete('/api/article/del_article', {
          params: {
            article_id: row.id,
            user_id: this.$store.state.userid
          }
        })
        .then(res => {
          var rcode = res.data.code
          this.totalNum = res.data.data.total
          this.tableData = res.data.data.zs_list
          if (rcode !== 200) {
            // 返回并清除token信息并跳转到登录页面
            this.$store.commit('REMOVE_COUNT')
            this.$router.push('/login')
          } else {
            this.$message.success('删除记录成功！')
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 转打印页面
    jumpPrint (index, row) {
      this.$router.push({
        path: '/printpage',
        query: {
          id: row.id
        }
      })
    },
    // 改变每页显示页数事件
    handleSizeChange (val) {
      this.pageSize = val
      // console.log(`每页 ${val} 条`)
      this.searchStr(this.pageSize, this.currentPage, 1)
    },
    // 改变跳转页数事件
    handleCurrentChange (val) {
      this.currentPage = val
      // console.log(`当前页: ${val}`)
      this.searchStr(this.pageSize, this.currentPage, 1)
    },
    // 全部选定事件
    handleSelectionChange (val) {
      this.multipleSelection = val
      // 选择两项以上，批量删除按键可用
      if (this.multipleSelection.length > 1) {
        this.plif = false
      } else {
        this.plif = true
      }
    },
    // 添加新记录
    jtadd () {
      this.$router.push('/adddata')
    },
    // 批量删除
    jtdel (index, rows) {
      let ids = []
      for (let i of this.multipleSelection) {
        ids.push(i.id)
      }
      this.$http
        // dev
        // .delete('/api/delartes', {
        //   params: {
        //     article_ids: ids,
        //     user_id: this.$store.state.userid
        //   }
        // })
        // product
        .delete('/api/article/del_atles', {
          params: {
            article_ids: ids,
            user_id: this.$store.state.userid
          }
        })
        .then(res => {
          var rcode = res.data.code
          this.totalNum = res.data.data.total
          this.tableData = res.data.data.zs_list
          if (rcode !== 200) {
            // 返回并清除token信息并跳转到登录页面
            this.$store.commit('REMOVE_COUNT')
            this.$router.push('/login')
          } else {
            this.$message.success('删除记录成功！')
            if (rows) {
              rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row)
              })
            } else {
              this.$refs.multipleTable.clearSelection()
            }
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 查询方法
    searchStr (num, page, type) {
      // 获取变量及参数
      var sch = this.search ? this.search : ''
      var dar = this.dateR ? this.dateR : ''
      var num = isNumber(num) ? num : this.pageSize
      var page = isNumber(page) ? page : this.currentPage
      var type = type ? type : 0           
     
      // dev-判断搜索条件
      // if (sch && !dar) {
      //   var schurl =
      //     '/api/search/' +
      //     this.$store.state.userid +
      //     '?search=' +
      //     sch +
      //     '&daterange=' +
      //     '&'
      // } else if (dar && !sch) {
      //   var schurl =
      //     '/api/search/' +
      //     this.$store.state.userid +
      //     '?search=&daterange=' +
      //     dar +
      //     '&'
      // } else if (dar && sch) {
      //   var schurl =
      //     '/api/search/' +
      //     this.$store.state.userid +
      //     '?search=' +
      //     sch +
      //     '&daterange=' +
      //     dar +
      //     '&'
      // } else {
      //   var schurl = '/api/article/' + this.$store.state.userid + '?'
      // }
      // product-判断搜索条件
      if (sch && !dar) {
        var schurl =
          '/api/article/search_list?user_id=' +
          this.$store.state.userid +
          '&search=' +
          sch +
          '&daterange=' +
          '&'
      } else if (dar && !sch) {
        var schurl =
          '/api/article/search_list?user_id=' +
          this.$store.state.userid +
          '&search=&daterange=' +
          dar +
          '&'
      } else if (dar && sch) {
        var schurl =
          '/api/article/search_list?user_id=' +
          this.$store.state.userid +
          '&search=' +
          sch +
          '&daterange=' +
          dar +
          '&'
      } else {
        var schurl =
          '/api/article/search_list?user_id=' + this.$store.state.userid + '&'
      }
      // 发送查询请求
      this.$http
        .get(schurl + 'num=' + num + '&page=' + page)
        .then(res => {
          var rcode = res.data.code
          this.totalNum = res.data.data.total
          this.tableData = res.data.data.zs_list
          if (rcode !== 200) {
            // 返回并清除token信息并跳转到登录页面
            this.$store.commit('REMOVE_COUNT')
            this.$router.push('/login')
          } else {
            if (!type) this.$message.success(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    // 编写日期格式化方法
    dateFormat (row, column) {
      const date = row[column.property]
      if (date === undefined) {
        return ''
      }
      // 这里的格式根据需求修改
      return this.$moment.unix(date).format('YYYY-MM-DD HH:mm:ss')
    },
    // 查询获取选择的时间范围
    getdateRange (val) {
      this.dateR = val || ''
    },
    // 直接打印
    handlePrint1 (id) {
      console.log(id)
      let LODOP = getLodop()
      LODOP.PRINT_INIT('采购单')
      LODOP.SET_PRINT_STYLE('FontSize', 18)
      LODOP.SET_PRINT_STYLE('Bold', 1)
      LODOP.ADD_PRINT_TEXT(50, 300, 260, 39, '采购单')
      LODOP.ADD_PRINT_HTM(
        88,
        200,
        350,
        600,
        document.getElementById('form1').innerHTML
      )
      LODOP.PRINT()
    },
    // 打印预览
    handlePrint2 (id) {
      this.getprintdata(id)
      console.log(id)
      let LODOP = getLodop()
      // LODOP.PRINT_INIT(this.items.fathername)
      LODOP.SET_PRINT_STYLE('FontSize', 18)
      LODOP.SET_PRINT_STYLE('Bold', 1)
      // LODOP.ADD_PRINT_TEXT(50, 300, 260, 39, this.items.fathername)
      LODOP.ADD_PRINT_HTM(
        88,
        200,
        350,
        600,
        document.getElementById('form1').innerHTML
      )
      LODOP.PREVIEW()
    },
    // 打印维护
    handlePrint3 (id) {
      console.log(id)
      LODOP.PRINT_SETUP()
    },
    // 打印设计
    handlePrint4 (id) {
      console.log(id)
      LODOP.PRINT_DESIGN()
    },
    // 获取打印数据
    getprintdata (id) {
      this.$http
        // dev
        // .get('/api/detail/' + id)
        // product
        .get('/api/queryfr/certificates_detail?id=' + this.$route.query.id)
        .then(res => {
          var rcode = res.data.code
          if (rcode !== 200) {
            this.$message.error(res.data.msg)
          } else {
            this.$message.success(res.data.msg)
            this.items = res.data.data
          }
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    }
  }
}
</script>

<style scoped>
.main {
  padding: 20px;
}
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background-color: #f2f2f2;
}
.el-table {
  margin-top: 30px;
}
.el-pagination {
  text-align: right;
  margin-top: 20px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
